import { h } from 'preact';
import { ListEntry } from '@epx/flow';

const TASK_TYPES = ['epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask', 'epx:ManualTask'];

const getNotificationTypes = (i18n) => [
  { value: 'Email', label: i18n['opt.Email'] || 'Email' },
  { value: 'SMS', label: i18n['opt.SMS'] || 'SMS' },
  { value: 'Push', label: i18n['opt.Push'] || 'Push Notification' },
];

export class SfdNotificationPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const notifications = props.notifications || [];

    const updateNotifications = (items) => {
      lf.setProperties(id, { notifications: items });
      lf.emit('node:properties-change', { id, properties: { notifications: items } });
    };

    const columns = [
      { key: 'notificationType', label: i18n.notificationType || 'Type', type: 'select', options: getNotificationTypes(i18n), width: '35%' },
      { key: 'notificationText', label: i18n.notificationText || 'Text', width: '60%' },
    ];

    return [
      {
        id: 'notifications',
        label: i18n.notifications || 'Notifications',
        badge: notifications.length || undefined,
        entries: [
          {
            id: 'notificationsList',
            component: () => (
              <ListEntry
                id="sfd-notifications"
                label=""
                items={notifications}
                columns={columns}
                addLabel={i18n.addNotification || '+ Add'}
                onAdd={() =>
                  updateNotifications([...notifications, { notificationType: 'Email', notificationText: '' }])
                }
                onRemove={(idx) => updateNotifications(notifications.filter((_, i) => i !== idx))}
                onChange={(idx, key, value) => {
                  const updated = notifications.map((n, i) => (i === idx ? { ...n, [key]: value } : n));
                  updateNotifications(updated);
                }}
              />
            ),
          },
        ],
        isEdited: () => notifications.length > 0,
      },
    ];
  }
}
